import React from 'react'
import data from './data.json'
import {
  Intro,
  Layout,
  Header,
  SectionTitle,
  Grid,
  GridItem,
} from '../../../../components'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <Intro>
          <p>
            Our voice and tone should reflect Wilmington Trust's brand and
            business philosophy, captured in the brand promise{' '}
            <strong>"A greater understanding."</strong> This phrase should be
            kept in mind when creating content, but only used directly in
            marketing contexts. We should strive to communicate that we’re
            focused on what’s important to our customers, which means we know
            them, understand their needs and work to provide a banking
            experience that supports them. Our content should work to support
            our overall brand characteristics, reinforcing friendlier,
            colloquial, branded language and move away from institutional,
            heavy, overwritten language. Copy should be easy to read, which
            means blocks of text should be made “scannable” by the use of
            subheads, bullets and short paragraphs whenever possible.
          </p>
        </Intro>
        <SectionTitle>Brand Characteristics</SectionTitle>
        <p>
          Where appropriate, content should explicitly or implicitly reinforce
          the characteristics that define Wilmington Trust:
        </p>
        <ul class="c-unordered-list">
          <li class="c-unordered-list__item">
            <strong>Hardworking</strong> - diligent, devoted, thorough
          </li>
          <li class="c-unordered-list__item">
            <strong>Reliable</strong> - trustworthy, consistent, dependable,
            steadfast
          </li>
          <li class="c-unordered-list__item">
            <strong>Straighforward</strong> - sincere, honest, open, genuine
          </li>
          <li class="c-unordered-list__item">
            <strong>Accessible</strong> - approachable, amicable, engaging,
            inviting
          </li>
          <li class="c-unordered-list__item">
            <strong>Insightful</strong> - perceptive, understanding, astute
          </li>
          <li class="c-unordered-list__item">
            <strong>Caring</strong> - community-minded, helpful, supportive
          </li>
          <li class="c-unordered-list__item">
            <strong>Forward-looking</strong> - optimistic, active, energetic
          </li>
        </ul>
        <SectionTitle>Voice</SectionTitle>
        <p>
          Our brand voice reflects our distinct personality, style and point of
          view, incorporating all of our brand characteristics. Wilmington Trust
          has a strong, established brand that values hard work, community and
          getting it right. The Wilmington Trust brand is embodied in content
          that simply and conversationally tells it like it is, rather than
          dressing up a product or service with dry, overly formal or
          unnecessary corporate jargon. Our brand voice speaks plainly, but not
          so casually as to cross over into sounding unprofessional or using
          slang. It’s a comfortable and confident style that is also
          approachable.
        </p>
        <SectionTitle>Tone</SectionTitle>
        <p>Our tone of voice (how we say it) is:</p>
        <ul class="c-unordered-list">
          <li class="c-unordered-list__item">Friendly</li>
          <li class="c-unordered-list__item">Conversational</li>
          <li class="c-unordered-list__item">Informative</li>
          <li class="c-unordered-list__item">Progressive</li>
          <li class="c-unordered-list__item l-margin-bottom--large">
            Reflective of the empathetic quality inherent in our "understanding"
            brand promise
          </li>
        </ul>
        <p>
          Tone influences the way customers feel when interacting with our
          brand. Content should have the "How can we help?" attitude that
          ultimately achieves the goal of empowering users.
        </p>
        <hr />
        <SectionTitle>How it Sounds</SectionTitle>
        <Grid>
          <GridItem columns="6">
            <div class="do">
              <div class="do__title">
                <i class="icon icon--success"></i> Friendly, Colloquial
              </div>
              <h3>Total Balance</h3>
              <p>
                This is the balance you had at the end of yesterday, plus or
                minus any transactions that process in real time. Any pending
                checks or other transactions are not included here. Refer to
                your Available Balance to see the amount you can access right
                now for withdrawals, transfers and payments.
              </p>
            </div>
          </GridItem>
          <GridItem columns="6">
            <div class="dont">
              <div class="dont__title">
                <i class="icon icon--error"></i> Institutional, Overly Formal
              </div>
              <h3>Total Balance</h3>
              <p>
                The previous business day’s ending balance, plus or minus
                certain limited transactions that are processed real-time.
                Balances from pending transactions that have not posted to your
                account may not be reflected. Your total balance also does not
                include checks or other transactions you may have initiated that
                have not yet been presented to the bank for payment. For the
                amount currently available for withdrawals, transfers, and
                payments, please refer to the Available Balance.
              </p>
            </div>
          </GridItem>
        </Grid>
      </Layout>
    </>
  )
}
